/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import { ExpandMore } from '@mui/icons-material';

export const expander = {
  id: 'expander',
  accessor: 'expander',
  Header: '',
  width: 40,
  disableResizing: true,
  Cell: ({ row }: { row: any }) => (
    <span
      {...row.getToggleRowExpandedProps({
        style: {
          paddingLeft: `${row.depth * 2}rem`,
        },
      })}
    >
      <ExpandMore
        style={row.isExpanded ? { transform: 'rotate(180deg)' } : { transform: 'rotate(0deg)' }}
      />
    </span>
  ),
};
